import { useState, useCallback, useRef } from 'react';
import { p9315Api } from '../../../services/p9315Api';

/**
 * Hook for looking up department name with caching.
 * Used for the filter inputs (department code from/to).
 */
export function useP9315Lookup() {
  const [deptFromName, setDeptFromName] = useState('');
  const [deptToName, setDeptToName] = useState('');
  const cache = useRef<Record<string, string>>({});

  const lookupDeptName = useCallback(async (code: string): Promise<string> => {
    const trimmed = code?.trim();
    if (!trimmed) return '';
    if (cache.current[trimmed] !== undefined) return cache.current[trimmed];

    const name = await p9315Api.lookupName('department', trimmed);
    cache.current[trimmed] = name;
    return name;
  }, []);

  const onDeptFromBlur = useCallback(async (code: string) => {
    const name = await lookupDeptName(code);
    setDeptFromName(name);
  }, [lookupDeptName]);

  const onDeptToBlur = useCallback(async (code: string) => {
    const name = await lookupDeptName(code);
    setDeptToName(name);
  }, [lookupDeptName]);

  const resetNames = useCallback(() => {
    setDeptFromName('');
    setDeptToName('');
  }, []);

  return { deptFromName, deptToName, onDeptFromBlur, onDeptToBlur, resetNames };
}
